import { reportApiError } from '../core/errors/api-error';
import React, { useState } from "react";
import { gql, useLazyQuery, useMutation } from "@apollo/client";

const EVENT_UPDATE_REQUESTS = gql`
  mutation SaveEventOccurred($input: InputEventOccurred!) {
    saveEventOccurred(input: $input)
  }
`;

const EVENT_REQUESTS = gql`
  query GetEventOccurred {
    eventOccurred {
      data {
        codigo
        descricao
        dataHoraGPS
        localizacao
        temperaturaArRetorno
        setPoint
        tipoEvento
        unidadeThermoking {
          codigo
          clienteMaster {
            temperaturas
          }
        }
        carretaMaster {
          codigo
          placa
        }
        viagemMaster {
          pontoOrigem
          pontoDestino
          dataHoraEmbarque
          dataHoraDesembarque
          perfilMaster {
            descricao
            minima
            maxima
            tolerancia
          }
        }
        motoristaMaster {
          nome
        }
      }
    }
  }
`;

export const useEventOcurred = () => {
  const [eventOcurred, setEventOcurred] = useState(null);

  const [fetchEventOccurred, {}] = useLazyQuery(EVENT_REQUESTS, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    onCompleted: (result) => {
      const { eventOccurred } = result;
      setEventOcurred(eventOccurred ? eventOccurred.data[0] : null);
    },
    onError: reportApiError,
  });

  const [setEventOccurred, {}] = useMutation(EVENT_UPDATE_REQUESTS, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {},
    onError: reportApiError,
  });

  const refreshEventOcurred = async () => {
    setEventOcurred(null);
    fetchEventOccurred();
  };

  const confirmEventOcurred = async (data) => {
    setEventOcurred(null);
    await setEventOccurred({
      variables: {
        input: {
          ...data,
        },
      },
    });
  };

  return [eventOcurred, refreshEventOcurred, confirmEventOcurred];
};
